<template>
    <div>
        <!--top message start-->
        <div v-show="showYn == 'Y'" class="n_payReg">
            <p>Please set up a payment method to purchase diverse and abundant paid apps and fee-based premium content.  <a href="#">Register Payment Method</a><a class="btn_close" href="#"></a></p>
        </div>
        <!--top message end-->
        <!-- top area start-->
        <div id="header_ad">
            <div class="logoAd-wrap in-sec-ad">
                <img src="/img/ad/logo_lgapps.svg" alt="LG Apps" />
            </div>
        </div>
        <!--// top area end -->

        <!-- Container -->
        <div id="container_ad">
            <div id="contents_ad" class="in-sec-ad">
                <!-- contents -->
                <div class="section_ad">
                    <!-- S : 2018.10.19 Mod 홍병기K -->
                    <div class="controllerComment" v-html="$t('sdp.ad.list.message.001')"></div>
                    <div class="controller-wrap">
                        <div class="controller">
                            <h3>{{ $t("sdp.ad.list.message.002") }}</h3> <!-- 2020.10.22 Add 홍병기C -->
                            <!-- S : 2021.11.22 Add 홍병기C -->
                            <dl v-html="$t('sdp.ad.list.message.004')" class="bd0"></dl>
                            <!-- E : 2021.11.22 Add 홍병기C -->
                            <!-- START - C20200721_72823 : PC Website 약관에 표기된 링크 내용 업데이트 요청 드립니다. -->
                            <dl v-html="$t('sdp.ad.list.message.005')"></dl>
                            <!-- END - C20200721_72823 : PC Website 약관에 표기된 링크 내용 업데이트 요청 드립니다. -->
                            <!-- [ CSR_ID : 868980 ] 광고 3rd Party 안내페이지 업데이트 및 수정 요청드립니다. : N20191111_03615 : 삭제(Shared Information : IP address, Device information) 및 신규 안내 추가(Free Stream Media (d.b.a. SambaTV)) -->
                            <!-- 2025.06.09 송준형 : REQSDP-7594 - [pcmall] 광고 업체 리스트 웹사이트 업데이트 -->
                            <dl v-html="$t('sdp.ad.list.message.006')"></dl>
                            <!-- start-2026.03.23 송준형 : REQSDP-10243 - [pcmall] 광고 업체 리스트 웹사이트 업데이트 -->
                            <dl v-html="$t('sdp.ad.list.message.007')"></dl>
                            <dl v-html="$t('sdp.ad.list.message.008')"></dl>
                            <dl v-html="$t('sdp.ad.list.message.009')"></dl>
                            <dl v-html="$t('sdp.ad.list.message.010')"></dl>
                            <dl v-html="$t('sdp.ad.list.message.011')"></dl>
                            <!-- end-2026.03.23 송준형 : REQSDP-10243 - [pcmall] 광고 업체 리스트 웹사이트 업데이트 -->
                        </div>

                        <!-- S : 2020.10.22 Add 홍병기C -->
                        <div class="controller">
                            <h3>{{ $t("sdp.ad.list.message.003") }}</h3>
                            <!--<div class="OTmodels">SUNNY, BRANDT, HOHO, KONKA, VOX, RCA, WESTINGHOUSE, SPELER, JVC, VIDEOTEX, XORO, Element, Newsan, TDSYSTEMS, EKO, Philco, Infinition, BLAUPUNKT, QBELL, ZEPHIR, MAKENA, POLAROID, HYUNDAI, SANLUX, TEAC, AIWA, NPC, ABANS, SONIQ</div>-->
                            <!-- S : 2021.11.22 Add 홍병기C -->
                            <dl v-html="$t('sdp.ad.list.message.004')" class="bd0"></dl>
                            <!-- E : 2021.11.22 Add 홍병기C -->
                            <!-- S : 2021.11.10 Add 홍병기C -->
                            <dl v-html="$t('sdp.ad.list.message.005')"></dl>
                            <!-- E : 2021.11.10 Add 홍병기C -->
                            <!-- 2025.06.09 송준형 : REQSDP-7594 - [pcmall] 광고 업체 리스트 웹사이트 업데이트 -->
                            <dl v-html="$t('sdp.ad.list.message.006')"></dl>
                            <!-- start-2026.03.23 송준형 : REQSDP-10243 - [pcmall] 광고 업체 리스트 웹사이트 업데이트 -->
                            <dl v-html="$t('sdp.ad.list.message.007')"></dl>
                            <dl v-html="$t('sdp.ad.list.message.008')"></dl>
                            <dl v-html="$t('sdp.ad.list.message.009')"></dl>
                            <dl v-html="$t('sdp.ad.list.message.010')"></dl>
                            <dl v-html="$t('sdp.ad.list.message.011')"></dl>
                            <!-- end-2026.03.23 송준형 : REQSDP-10243 - [pcmall] 광고 업체 리스트 웹사이트 업데이트 -->
                        </div>
                        <div class="line"></div>
                        <!-- E : 2020.10.22 Add 홍병기C -->
                    </div>
                    <!-- E : 2018.10.19 Mod 홍병기K -->
                </div>
                <!-- /contents -->
            </div>
        </div>
        <!-- //Container -->

        <!-- FooterArea -->
        <div id="footer_ad">
            <div class="footer_inner in-sec-ad">
                <div class="main_footer center">
                    <img src="/img/ad/logo_footer.gif" alt="LG Electronics" />
                    <!-- <p class="copyright">COPYRIGHT ⓒ LG ELECTRONICS. ALL RIGHTS RESERVED.</p> [ CSR_ID : 868980 ] 광고 3rd Party 안내페이지 업데이트 및 수정 요청드립니다. : N20191111_03615 -->
                    <p class="copyright">COPYRIGHT &#169; LG ELECTRONICS. ALL RIGHTS RESERVED.</p>
                </div>

            </div>
        </div>
        <!--// FooterArea -->
    </div>
</template>

<script>
    export default {
        name: "AdList",
        data() {
            return {
                showYn: "N",
                cntryCode: _domainCntryCode // 2025.08.22 송준형 : REQSDP-8356 - [pcmall] 광고 업체 리스트 웹사이트 업데이트
            }
        },
        mounted() {
            $("#header").hide();
            $("#footer").hide();
        },
        watch: {
            $route: "fetchData"
        },
        computed: {
        },
        methods: {
            track () {
                console.log('@@@@ track:', this.$router.currentRoute.path);
                this.$ga.page(this.$router.currentRoute.path)
            }
        }
    }
</script>

<style scoped>

</style>